import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import { Accordion } from "@/components/ui/accordion";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeAccordionItemSkeleton } from "@/types/contentful/generated";
import { AccordionFullWidthItem } from "./AccordionFullWidthItem";
type AccordionItemEntry = Entry<TypeAccordionItemSkeleton, undefined, string>;
type ItemBlock = AccordionItemEntry | UnresolvedLink<"Entry">;
interface Props {
  items: ItemBlock[];
  isFirstItemExpanded?: boolean;
}
export default function AccordionFullWidth(t0) {
  const $ = _c(16);
  const {
    items,
    isFirstItemExpanded
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== isFirstItemExpanded || $[1] !== items) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolvedItems = items.filter(_temp);
      if (resolvedItems.length === 0) {
        t5 = null;
        break bb0;
      }
      const defaultValue = isFirstItemExpanded ? [resolvedItems[0].sys.id] : [];
      t4 = "w-full max-w-site-content mx-auto p-6";
      T0 = Accordion;
      t1 = "multiple";
      t2 = defaultValue;
      t3 = resolvedItems.map(_temp2);
    }
    $[0] = isFirstItemExpanded;
    $[1] = items;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[8] !== T0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t6 = <T0 type={t1} defaultValue={t2}>{t3}</T0>;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp2(item_0) {
  return <AccordionFullWidthItem key={item_0.sys.id} item={item_0} />;
}
function _temp(item) {
  return isEntry(item);
}